import { createFileRoute, redirect } from '@tanstack/react-router';
import { destinationSearch, toSignIn } from '@/lib/destination';
import { WelcomePage } from '@/page/WelcomePage';

/** Leaving is WelcomePage's job. This guard only handles arrival. */
export const Route = createFileRoute('/welcome')({
  validateSearch: destinationSearch,
  beforeLoad: ({ context, location }) => {
    const account = context.account();
    if (!account) throw toSignIn(location);
    if (account.onboardedAt !== undefined) throw redirect({ to: '/', replace: true });
  },
  component: WelcomeRoute,
});

function WelcomeRoute() {
  const { redirect_url } = Route.useSearch();
  return <WelcomePage destination={redirect_url ?? '/'} />;
}
